import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import { connect } from "react-redux";
import { Scheduler, Button, Popup, ValidationGroup } from "devextreme-react";
import { CuposItem } from "../cuposItem";
import TextField from "../../../../../Shared/fields/TextField";
import { setOpening, setStepWizard, doCreateUpdateOpening, setNameConflictModal } from "../actions";
import TooltipBody from "./TooltipBody";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import validaciones from "../../../../../../helpers/validaciones";
import OpeningValidation from "./openigValidation";

class formMatrizApertura extends React.PureComponent {
  constructor(props) {
    super(props);
    this.data = null;
    this.lastTimeInterval = "";
  }

  handleBack = () => {
    this.props.dispatch(setStepWizard({
      stepOne: false,
      stepTwo: true,
      stepThree: false,
      stepSuccess: false,
    }));
  }
  openCloseModal = (value) => {
    this.props.dispatch(setNameConflictModal(value));
  }
  handleOpenName = () => {
    const NewOpening = { ...this.props.Opening };
    if (NewOpening.isNewConfig === true) {
      this.openCloseModal(true);
    } else {
      this.sendData();
    }
  }
  handleClose = () => {
    this.openCloseModal(false);
  }

  handleChangeNameOpeninig = (e) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.NameOpening = e.value;

    this.props.dispatch(setOpening(NewOpening));
  }

  handleAppointmentClick = (event) => {
    this.data = event.appointmentData;
  }

  handleEnd = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      this.sendData();
    }
  }

  nameValidation = (e) => {
    if (e.value !== null) {
      return true;
    }

    return false;
  }

  sendData = () => {
    const Op = { ...this.props.Opening };
    const config = {};
    const center = {};
    const Pools = [];
    const Exams = [];
    const Modules = [];
    const send = {};

    send.Id = Op.Id;
    config.Id = Op.isNewConfig === true ? 0 : Op.IdConfig;
    config.Description = Op.NameOpening;
    config.WorkingDays = Op.workDays.map((d) => d.index);
    config.StartTime = Op.startWorkDay;
    config.EndTime = Op.endWorkDay;
    config.StartTimeSaturday = Op.satWorkstart ? Op.satWorkstart : null;
    config.EndTimeSaturday = Op.satWorkEnd ? Op.satWorkEnd : null;
    config.StartTimeSunday = Op.sunWorkStart ? Op.sunWorkStart : null;
    config.EndTimeSunday = Op.sunWorkEnd ? Op.sunWorkEnd : null;
    center.Id = Op.IdCentro;
    center.Description = "test";
    config.Center = center;
    Op.ExamPools.forEach((ep) => {
      Pools.push({ Id: ep });
    });
    Op.Exams.forEach((e) => {
      Exams.push({ Id: e });
    });
    Op.Ciel.forEach((e) => {
      Exams.push({ Id: e });
    });

    config.Pools = Pools;
    config.Exams = Exams;
    config.ModuleDuration = Op.moduleTime;
    send.StartDate = Op.startDate;
    send.EndDate = Op.endDate;

    Op.data.forEach((m) => {
      Modules.push({
        Day: m.day === 7 ? 0 : m.day,
        StartTime: moment(m.startDate, "HH:mm").format("HH:mm"),
        EndTime: moment(m.endDate, "HH:mm").format("HH:mm"),
        Quotas: m.Quotas,
      });
    });
    config.Modules = Modules;
    this.openCloseModal(false);
    send.Configuration = config;
    this.props.dispatch(doCreateUpdateOpening(send));
  }

  renderTooltipBodyOpening = (appointment) => <TooltipBody data={appointment} />

  renderNameOpening = () => {
    const NewOpening = { ...this.props.Opening };
    return (

      <ValidationGroup className="row">
        <div className="col-12">
          <TextField
            label="Nombre de la apertura"
            required
            maxLength={80}
            id="NameOpening"
            onChange={this.handleChangeNameOpeninig}
            value={NewOpening.NameOpening}
            customRules={{
              type: "custom",
              validationCallback: this.nameValidation,
              message: "El nombre es requerido",
            }}
          />
        </div>
        <div className="button-row">
          <div>
            <Button
              onClick={this.handleClose}
              text="cerrar"
            />
          </div>
          <div>
            <Button
              onClick={this.handleEnd}
              type="success"
              text="Agregar"
            />
          </div>
        </div>
      </ValidationGroup>
    );
  }

  renderWeekItem = (data, index, element) => {
    ReactDOM.render(
      <CuposItem data={data} />
      , element
    );
  }

  render() {
    const {
      validationOpening,
    } = this.props;
    return (
      <div
      // style={{ height: 410, overflow: "hidden", overflowY: "auto" }}
      >
        <div style={{ marginLeft: -15, marginTop: 10 }}>
          {this.props.isLoading && <LoadingOverlay />}
          <Scheduler
            height={400}
            className="simple-scheduler-view opening-view-month"
            dataSource={this.props.Opening.data}
            defaultCurrentView="day"
            views={[
              {
                name: "day",
                type: "day",
                groupOrientation: "horizontal",
                maxAppointmentsPerCell: "unlimited",
                cellDuration: this.props.config.cellDuration,
                appointmentTemplate: this.renderWeekItem,
                intervalCount: 1,
              },
            ]}
            defaultCurrentDate={new Date()}
            startDayHour={this.props.config.startDayHour}
            endDayHour={this.props.config.endDayHour}
            crossScrollingEnabled
            cellDuration={this.props.Opening.moduleTime}
            groups={["day"]}
            showAllDayPanel={false}
            resources={[
              {
                fieldExpr: "day",
                valueExpr: "order",
                allowMultiple: false,
                dataSource: this.props.Opening.priorityData,
              },
            ]}
            timeCellTemplate={(data, index, element) => {
              let { text } = data;
              if (data.text === "") {
                text = validaciones.getTimeForInterval(this.lastTimeInterval, this.props.Opening.moduleTime);
              } else {
                this.lastTimeInterval = text;
              }
              ReactDOM.render(<span>{text}</span>, element);
            }}
            editing={{
              allowAdding: false,
              allowDragging: false,
              allowResizing: false,
              allowUpdating: false,
              allowDeleting: false,
            }}
            showCurrentTimeIndicator={false}
            onAppointmentDblClick={(e) => {
              e.cancel = true;
            }}
            onAppointmentClick={this.handleAppointmentClick}
            appointmentTooltipRender={this.renderTooltipBodyOpening}
          />

          <div className="button-row">
            <div>
              <Button
                onClick={this.handleBack}
                text="Volver"
              />
            </div>
            <div>
              <Button
                onClick={this.handleOpenName}
                type="success"
                text="Finalizar"

              />
            </div>
          </div>
          <Popup
            visible={this.props.isModalNameAndConflictOpen}
            showTitle
            title={validationOpening.openValidation === false ? "Nueva Apertura" : "Conflictos"}
            maxWidth={500}
            height={250}
            onHiding={this.handleClose}
            showCloseButton
            dragEnabled={false}
          >
            <div>
              {
                validationOpening.openValidation === false ? this.renderNameOpening() : <OpeningValidation />

              }
            </div>
          </Popup>
        </div>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  centerSelected: state.aperturasSel.centerSelected,
  config: state.aperturasSel.configSchedulerWizard,
  Opening: state.aperturasSel.Opening,
  validationOpening: state.aperturasSel.validationOpening,
  isLoading: state.aperturasSel.isLoading,
  isModalNameAndConflictOpen: state.aperturasSel.isModalNameAndConflictOpen,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(formMatrizApertura);
